import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import moment from 'moment';
import CalendarContainer from './CalendarContainer';
import onClickOutside from 'react-onclickoutside';
import DOM from 'react-dom-factories';
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/hr';

var nof = function () {};

class Datetime extends Component {
  static propTypes = {
    value: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    viewDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    className: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    spanClassName: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    // prevIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    // nextIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    // defaultValue: PropTypes.object | PropTypes.string,
    // onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    locale: PropTypes.string,
    utc: PropTypes.bool,
    input: PropTypes.bool,
    dateFormat: PropTypes.oneOfType([ PropTypes.string, PropTypes.bool, PropTypes.func ]),
    // timeFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.func]),
    minDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    maxDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    inputProps: PropTypes.object,
    // timeConstraints: PropTypes.object,
    viewMode: PropTypes.oneOf([ 'years', 'months', 'days', 'time' ]),
    // isValidDate: PropTypes.func,
    open: PropTypes.bool,
    // strictParsing: PropTypes.bool,
    closeOnSelect: PropTypes.bool,
    closeOnTab: PropTypes.bool,
    alwaysVisible: PropTypes.bool,
    fullMonth: PropTypes.bool,
    hideDatePreview: PropTypes.bool,
    showDayText: PropTypes.bool,
    showDayIcon: PropTypes.bool,
    id: PropTypes.string,
    dayRenderingAdditions: PropTypes.arrayOf(PropTypes.object),
  };

  static defaultProps = {
    className: '',
    spanClassName: '',
    defaultValue: '',
    inputProps: {},
    input: true,
    toggleCalendar: nof,
    openCalendar: nof,
    onFocus: nof,
    onBlur: nof,
    onChange: nof,
    timeConstraints: {},
    dateFormat: true,
    timeFormat: true,
    strictParsing: true,
    closeOnSelect: false,
    alwaysVisible: false,
    open: false,
    closeOnTab: true,
    utc: false,
    fullMonth: false,
    dayRenderingAdditions: [],
  };

  constructor (props) {
    super(props);

    let state = this.getStateFromProps(props);

    let minDate =
      typeof props.minDate === 'object' ?
        moment(props.minDate).format('MM/DD/YYYY HH:mm:ss') :
        props.minDate;
    let maxDate =
      typeof props.maxDate === 'object' ?
        moment(props.maxDate).format('MM/DD/YYYY HH:mm:ss') :
        props.maxDate;
    state.minDate = minDate;
    state.maxDate = maxDate;

    if (state.open === undefined) state.open = !props.input;

    state.currentView = props.dateFormat ? props.viewMode || state.updateOn || 'days' : 'time';

    this.setDate = this.setDate.bind(this);
    this.setTime = this.setTime.bind(this);
    this.addTime = this.addTime.bind(this);
    this.showView = this.showView.bind(this);
    this.blurInput = this.blurInput.bind(this);
    this.updateTime = this.updateTime.bind(this);
    this.localMoment = this.localMoment.bind(this);
    this.subtractTime = this.subtractTime.bind(this);
    this.openCalendar = this.openCalendar.bind(this);
    this.closeCalendar = this.closeCalendar.bind(this);
    this.toggleCalendar = this.toggleCalendar.bind(this);
    this.updateSelectedDate = this.updateSelectedDate.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.onChange = props.onChange;

    this.componentProps = {
      fromProps: [
        'value',
        'prevIcon',
        'nextIcon',
        'viewDate',
        'isValidDate',
        'renderDay',
        'renderMonth',
        'renderYear',
        'timeConstraints',
        'alwaysVisible',
        'fullMonth',
        'dayRenderingAdditions',
        'showDayText',
        'showDayIcon',
      ],
      fromState: [ 'viewDate', 'selectedDate', 'updateOn', 'minDate', 'maxDate' ],
      fromThis: [
        'updateTime',
        'setDate',
        'setTime',
        'showView',
        'addTime',
        'subtractTime',
        'updateSelectedDate',
        'localMoment',
        'handleClickOutside',
      ],
    };

    this.allowedSetTime = [ 'hours', 'minutes', 'seconds', 'milliseconds' ];

    this.state = state;
  }

  getStateFromProps (props) {
    let formats = this.getFormats(props);
    let date = props.value || props.defaultValue;
    let selectedDate;
    let viewDate;
    let updateOn;
    let inputValue;
    if (date && typeof date === 'string') {
      selectedDate = this.localMoment(date, formats.datetime);
    } else if (date) selectedDate = this.localMoment(date);

    if (selectedDate && !selectedDate.isValid()) selectedDate = null;

    viewDate = selectedDate ?
      selectedDate.clone().startOf('month') :
      this.localMoment().startOf('month');

    updateOn = this.getUpdateOn(formats);

    if (selectedDate) inputValue = selectedDate.format(formats.datetime);
    else if (date.isValid && !date.isValid()) inputValue = '';
    else inputValue = date || '';

    return {
      updateOn: updateOn,
      inputFormat: formats.datetime,
      viewDate: viewDate,
      selectedDate: selectedDate,
      inputValue: inputValue,
      open: props.open,
    };
  }

  getUpdateOn (formats) {
    if (typeof formats.date === 'string') {
      if (formats.date.match(/[lLD]/)) {
        return 'days';
      } else if (formats.date.indexOf('M') !== -1) {
        return 'months';
      } else if (formats.date.indexOf('Y') !== -1) {
        return 'years';
      }
    }

    return 'days';
  }

  getFormats (props) {
    let formats = {
      date: props.dateFormat || '',
      time: props.timeFormat || '',
    };
    let locale = this.localMoment(props.date, null, props).localeData();

    if (formats.date === true) {
      formats.date = locale.longDateFormat('L');
    } else if (this.getUpdateOn(formats) !== 'days') {
      formats.time = '';
    }

    if (formats.time === true) {
      formats.time = locale.longDateFormat('LT');
    }

    formats.datetime =
      formats.date && formats.time ?
        formats.date + ' ' + formats.time :
        formats.date || formats.time;

    return formats;
  }

  componentWillReceiveProps (nextProps) {
    let formats = this.getFormats(nextProps);
    let updatedState = {};

    let minDate =
      typeof nextProps.minDate === 'object' ?
        moment(nextProps.minDate).format('MM/DD/YYYY HH:mm:ss') :
        nextProps.minDate;
    let maxDate =
      typeof nextProps.maxDate === 'object' ?
        moment(nextProps.maxDate).format('MM/DD/YYYY HH:mm:ss') :
        nextProps.maxDate;
    updatedState.minDate = minDate;
    updatedState.maxDate = maxDate;

    if (
      nextProps.value !== this.props.value ||
      formats.datetime !== this.getFormats(this.props).datetime
    ) {
      updatedState = this.getStateFromProps(nextProps);
    }

    if (updatedState.open === undefined) {
      if (
        this.props.closeOnSelect &&
        this.state.currentView !== 'time' &&
        !this.props.alwaysVisible
      ) {
        updatedState.open = false;
      } else {
        updatedState.open = this.state.open;
      }
    }

    if (nextProps.viewMode !== this.props.viewMode) {
      updatedState.currentView = nextProps.viewMode;
    }

    if (nextProps.locale !== this.props.locale) {
      if (this.state.viewDate) {
        let updatedViewDate = this.state.viewDate.clone().locale(nextProps.locale);
        updatedState.viewDate = updatedViewDate;
      }
      if (this.state.selectedDate) {
        let updatedSelectedDate = this.state.selectedDate.clone().locale(nextProps.locale);
        updatedState.selectedDate = updatedSelectedDate;
        updatedState.inputValue = updatedSelectedDate.format(formats.datetime);
      }
    }

    if (nextProps.utc !== this.props.utc) {
      if (nextProps.utc) {
        if (this.state.viewDate) {
          updatedState.viewDate = this.state.viewDate.clone().utc();
        }
        if (this.state.selectedDate) {
          updatedState.selectedDate = this.state.selectedDate.clone().utc();
          updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
        }
      } else {
        if (this.state.viewDate) {
          updatedState.viewDate = this.state.viewDate.clone().local();
        }
        if (this.state.selectedDate) {
          updatedState.selectedDate = this.state.selectedDate.clone().local();
          updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
        }
      }
    }

    this.setState(updatedState);
  }

  onInputChange (e) {
    let value = e.target === null ? e : e.target.value;
    let localMoment = this.localMoment(value, this.state.inputFormat);
    let update = { inputValue: value };

    if (localMoment.isValid() && !this.props.value) {
      update.selectedDate = localMoment;
      update.viewDate = localMoment.clone().startOf('month');
    } else {
      update.selectedDate = null;
    }

    return this.setState(update, function () {
      return this.onChange(localMoment.isValid() ? localMoment : this.state.inputValue);
    });
  }

  onInputKey (e) {
    if (e.which === 9 && this.props.closeOnTab) {
      this.closeCalendar();
    }
  }

  showView (view) {
    let me = this;
    return function () {
      me.setState({ currentView: view });
    };
  }

  setDate (type) {
    let me = this;
    let nextViews = {
      month: 'days',
      year: 'months',
    };

    return function (e) {
      me.setState({
        viewDate: me.state.viewDate
          .clone()
          [ type ](parseInt(e.target.getAttribute('data-value'), 10))
          .startOf(type),
        currentView: nextViews[ type ],
      });
    };
  }

  updateTime (op, amount, type, toSelected) {
    let me = this;

    return function () {
      let update = {};
      let date = toSelected ? 'selectedDate' : 'viewDate';

      update[ date ] = me.state[ date ].clone()[ op ](amount, type);

      me.setState(update);
    };
  }

  addTime (amount, type, toSelected) {
    return this.updateTime('add', amount, type, toSelected);
  }

  subtractTime (amount, type, toSelected) {
    return this.updateTime('subtract', amount, type, toSelected);
  }

  setTime (type, value) {
    let index = this.allowedSetTime.indexOf(type) + 1;
    let state = this.state;
    let date = (state.selectedDate || state.viewDate).clone();
    let nextType;

    // It is needed to set all the time properties
    // to not to reset the time
    date[ type ](value);
    for (; index < this.allowedSetTime.length; index++) {
      nextType = this.allowedSetTime[ index ];
      date[ nextType ](date[ nextType ]());
    }

    if (!this.props.value) {
      this.setState({
        selectedDate: date,
        inputValue: date,
      });
    }
    this.onChange(date);
  }

  updateSelectedDate (e, close) {
    let target = e.target;
    let modifier = 0;
    let viewDate = this.state.viewDate;
    let currentDate = this.state.selectedDate || viewDate;
    let date;

    if (target && typeof target.className !== 'string') {
      target = target.parentNode || target.parentElement;
      if (typeof target.className !== 'string') return;
    }

    if (target.className.indexOf('date-time-picker-day') !== -1) {
      if (target.className.indexOf('date-time-picker-new') !== -1) modifier = 1;
      else if (target.className.indexOf('date-time-picker-old') !== -1) modifier = -1;

      date = viewDate
        .clone()
        .month(viewDate.month() + modifier)
        .date(parseInt(target.getAttribute('data-value'), 10));
    } else if (target.className.indexOf('date-time-picker-month') !== -1) {
      date = viewDate
        .clone()
        .month(parseInt(target.getAttribute('data-value'), 10))
        .date(currentDate.date());
    } else if (target.className.indexOf('date-time-picker-year') !== -1) {
      date = viewDate
        .clone()
        .month(currentDate.month())
        .date(currentDate.date())
        .year(parseInt(target.getAttribute('data-value'), 10));
    }

    date
      .hours(currentDate.hours())
      .minutes(currentDate.minutes())
      .seconds(currentDate.seconds())
      .milliseconds(currentDate.milliseconds());

    if (!this.props.value || !this.state.selectedDate) {
      let open = !(this.props.closeOnSelect && close);
      if (!open) {
        this.props.onBlur(date);
      }

      this.setState({
        selectedDate: date,
        viewDate: date.clone().startOf('month'),
        inputValue: date.format('MM/DD/YYYY'),
        open: open,
      });
    } else {
      if (this.props.closeOnSelect && close) {
        this.closeCalendar();
      }
    }

    let additionalObjectForDate = {};
    if (this.props.dayRenderingAdditions) {
      let selectedDate = date ? date.format('MM/DD/YYYY') : null;
      // selectedDate = selectedDate ? new Date(selectedDate) : null;
      // selectedDate = selectedDate ? selectedDate.getTime() : null;
      if (selectedDate) {
        for (let i = 0; i < this.props.dayRenderingAdditions.length; i++) {
          let day = this.props.dayRenderingAdditions[ i ];
          let additionalDataDate = day && day.date ? new Date(day.date) : null;
          additionalDataDate = additionalDataDate ? additionalDataDate.getTime() : null;

          if (moment(additionalDataDate).format('MM/DD/YYYY') === selectedDate) {
            additionalObjectForDate = day;
            break;
          }
        }
      }
    }
    date = date ? date.format('MM/DD/YYYY') : null;
    this.onChange(date, additionalObjectForDate);
  }

  toggleCalendar () {
    if (this.props.alwaysVisible) {
      return;
    }
    if (this.state.open) {
      this.closeCalendar();
    } else {
      this.openCalendar();
    }
  }

  openCalendar () {
    if (!this.state.open) {
      this.setState({ open: true });
    }
  }

  closeCalendar () {
    this.setState({ open: false }, this.blurInput);
  }

  blurInput () {
    this.props.onBlur(this.state.selectedDate || this.state.inputValue);
  }

  handleClickOutside () {
    if (this.props.alwaysVisible) {
      return;
    }

    if (this.state.open) {
      if (this.props.input) {
        this.setState({ open: false }, this.blurInput);
      } else {
        this.setState({ open: false });
      }
    }
  }

  localMoment (date, format, props) {
    props = props || this.props;
    let momentFn = props.utc ? moment.utc : moment;
    let m = momentFn(date, format, props.strictParsing);
    if (props.locale) {
      m = m.locale(props.locale);
    }
    return m;
  }

  getComponentProps () {
    let me = this;
    let formats = this.getFormats(this.props);
    let props = { dateFormat: formats.date, timeFormat: formats.time };

    this.componentProps.fromProps.forEach(function (name) {
      props[ name ] = me.props[ name ];
    });
    this.componentProps.fromState.forEach(function (name) {
      props[ name ] = me.state[ name ];
    });
    this.componentProps.fromThis.forEach(function (name) {
      props[ name ] = me[ name ];
    });

    return props;
  }

  render () {
    let className =
      'date-time-picker-' +
      (this.props.className ?
        Array.isArray(this.props.className) ?
          ' ' + this.props.className.join(' ') :
          ' ' + this.props.className :
        '');
    let children = [];

    if (this.props.input) {
      children = [
        DOM.input(
          assign(
            {
              id: 'INPUT_' + this.props.id,
              key: 'input i',
              type: 'text',
              readOnly: 'readOnly',
              className: 'form-control',
              onFocus: this.openCalendar,
              onChange: this.onInputChange,
              onKeyDown: this.onInputKey,
              value: this.state.inputValue,
            },
            this.props.inputProps
          )
        ),
        DOM.span(
          assign({
            id: 'ICON_' + this.props.id,
            key: 'span i',
            className: 'input-group-addon fa icon-calendar',
            onClick: this.toggleCalendar,
          })
        ),
      ];

      children = [
        DOM.div(
          {
            id: 'INPUT_GROUP_DIV_' + this.props.id,
            key: 'wrapper i',
            className: 'input-group',
          },
          children
        ),
      ];
    } else {
      children = [
        DOM.span(
          assign(
            {
              id: 'DATE_' + this.props.id,
              key: 'span i',
              onChange: this.onInputChange,
              onKeyDown: this.onInputKey,
              children: this.props.viewDate || this.state.inputValue,
              onClick: this.toggleCalendar,
              style: { cursor: 'pointer' },
              className: this.props.spanClassName,
            },
            this.props.inputProps
          )
        ),
      ];
      // className += ' date-time-picker-static';
    }

    if (this.props.hideDatePreview) children = [];

    if (this.state.open) className += ' date-time-picker-open';

    return DOM.div(
      { className: className, id: this.props.id },
      children.concat(
        DOM.div(
          { key: 'dt', className: 'date-time-picker', id: 'PICKER_' + this.props.id },
          createElement(CalendarContainer, {
            view: this.state.currentView,
            viewProps: this.getComponentProps(),
            onClickOutside: this.handleClickOutside,
          })
        )
      )
    );
  }
}

Datetime.moment = moment;

export default onClickOutside(Datetime);



// WEBPACK FOOTER //
// ./src/containers/date-time-picker/DateTime.js